/** English — full key set for user/agent panels + auth (source of truth). */
export default {
  'common.theme': 'Theme',
  'common.themeLight': 'Light',
  'common.themeDark': 'Dark',
  'common.ariaSwitchToLightTheme': 'Switch to light theme',
  'common.ariaSwitchToDarkTheme': 'Switch to dark theme',
  'common.ariaToggleMobileSidebar': 'Toggle sidebar',
  'common.ariaCloseSidebarBackdrop': 'Close sidebar backdrop',
  'common.ariaAccountMenu': 'Account menu',
  'common.settings': 'Settings',
  'common.loading': 'Loading…',
  'common.dash': '—',

  'site.docTitle': '{{page}} | MineMe — High-Yield Investment Platform',
  'site.brandLine': 'MineMe — High-Yield Investment Platform',

  'settings.language': 'Language',
  'settings.languagePlaceholder': 'Select language',
  'settings.savePreferences': 'Save preferences',
  'settings.savingPreferences': 'Saving…',

  'common.themeActive': 'Currently active',
  'common.themeSwitchToDark': 'Switch to dark',
  'common.themeSwitchToLight': 'Switch to light',

  'settings.currency': 'Currency',
  'settings.selectCurrency': 'Select currency',

  'settings.languageOption.englishEn': 'English (EN)',
  'settings.languageOption.spanish': 'Spanish',
  'settings.languageOption.mandarinChinese': 'Mandarin Chinese',
  'settings.languageOption.arabic': 'Arabic',
  'settings.languageOption.french': 'French',
  'settings.languageOption.hindi': 'Hindi',
  'settings.languageOption.portuguese': 'Portuguese',
  'settings.languageOption.russian': 'Russian',
  'settings.languageOption.bengali': 'Bengali',
  'settings.languageOption.german': 'German',
  'settings.languageOption.japanese': 'Japanese',
  'settings.languageOption.korean': 'Korean',
  'settings.languageOption.italian': 'Italian',

  'settings.tab.profile': 'Profile',
  'settings.tab.security': 'Security',
  'settings.tab.preferences': 'Preferences',

  'settings.shell.loading': 'Loading settings…',
  'settings.shell.errorTitle': "Couldn't load your settings",
  'settings.shell.errorHint':
    'Check your connection, or sign out and sign in again if your session expired.',
  'settings.shell.tryAgain': 'Try again',
  'settings.shell.sessionExpired': 'Session expired — please sign in again',
  'settings.shell.loadProfileFailed': 'Could not load profile',
  'settings.shell.invalidProfile': 'Invalid profile response',
  'settings.shell.saveFailed': 'Save failed',

  'user.settings.intro': 'Update your profile, security, and preferences for this account.',
  'agent.settings.intro':
    'Update your profile, security, and display preferences for this agent account.',

  'settings.notifications.sectionTitle': 'Notifications',
  'settings.notifications.toggle.emailNotifications.label': 'Email notifications',
  'settings.notifications.toggle.emailNotifications.desc': 'Receive updates via email',
  'settings.notifications.toggle.depositAlerts.label': 'Deposit alerts',
  'settings.notifications.toggle.depositAlerts.desc': 'Notified when deposits are confirmed',
  'settings.notifications.toggle.withdrawalAlerts.label': 'Withdrawal alerts',
  'settings.notifications.toggle.withdrawalAlerts.desc': 'Notified on withdrawal status changes',
  'settings.notifications.toggle.investmentUpdates.label': 'Investment updates',
  'settings.notifications.toggle.investmentUpdates.desc':
    'Monthly interest and plan notifications',
  'settings.notifications.toggle.referralAlerts.label': 'Referral alerts',
  'settings.notifications.toggle.referralAlerts.desc': 'Earn notifications from referral activity',

  'user.settings.preferences.summary':
    '{{enabled}} of {{total}} email alert types are on. Open the dialog to change deposit, withdrawal, and other notification settings.',
  'user.settings.preferences.manage': 'Manage notification preferences',
  'user.settings.preferences.modalTitle': 'Notification preferences',
  'user.settings.preferences.modalHint':
    'Choose which account emails we send. You can update these anytime.',
  'user.settings.preferences.toastNotificationsSaved': 'Notification preferences saved',
  'user.settings.preferences.saveNotifications': 'Save notifications',
  'settings.preferences.toastSaved': 'Preferences saved',

  'settings.security.recoveryTitle': 'Recovery phrase',
  'settings.security.recoveryBefore':
    'Your 12-word phrase was shown once when you created your account. We do not store it in plain text, so it cannot be displayed here. To reset a forgotten password, use',
  'settings.security.recoveryAfter': 'with your saved phrase.',
  'settings.security.forgotPasswordLink': 'Forgot password',

  'settings.password.title': 'Change password',
  'settings.password.current': 'Current password',
  'settings.password.new': 'New password',
  'settings.password.confirm': 'Confirm password',
  'settings.password.show': 'Show',
  'settings.password.hide': 'Hide',
  'settings.password.match': 'Passwords match',
  'settings.password.noMatch': 'Passwords do not match',
  'settings.password.errMinLen': 'Minimum 8 characters required',
  'settings.password.errSameAsCurrent': 'New password must be different from current',
  'settings.password.errMismatch': 'Passwords do not match',
  'settings.password.toastUpdateFailed': 'Could not update password',
  'settings.password.toastUpdated': 'Password updated successfully',
  'settings.password.submit': 'Update password',
  'settings.password.updating': 'Updating…',

  'settings.profile.cropPhotoAria': 'Choose photo to crop',
  'settings.profile.addNameHint': 'Add your full name in the form below.',
  'settings.profile.activeAccount': 'Active account',
  'settings.profile.choosePhoto': 'Choose photo',
  'settings.profile.working': 'Working…',
  'settings.profile.removePhoto': 'Remove photo',
  'settings.profile.infoTitle': 'Profile information',
  'settings.profile.fullName': 'Full name',
  'settings.profile.placeholderFullName': 'Your full name',
  'settings.profile.email': 'Email',
  'settings.profile.emailLockedHint': 'Email cannot be changed',
  'settings.profile.phone': 'Phone number',
  'settings.profile.phonePlaceholder': '+1… or digits only',
  'settings.profile.address': 'Address',
  'settings.profile.username': 'Username',
  'settings.profile.saveChanges': 'Save changes',
  'settings.profile.nameRequired': 'Full name is required',
  'settings.profile.updatedToast': 'Profile updated successfully',
  'settings.profile.uploadFailed': 'Upload failed',
  'settings.profile.removeFailed': 'Could not remove photo',
  'settings.profile.photoUpdated': 'Photo updated',
  'settings.profile.photoRemoved': 'Photo removed',
  'settings.profile.avatarFallbackLetter': '?',

  'settings.avatarCrop.hint':
    'Drag to reposition, use the slider to zoom. The photo is saved as a square.',
  'settings.avatarCrop.zoom': 'Zoom',
  'settings.avatarCrop.zoomAria': 'Crop zoom',
  'settings.avatarCrop.savePhoto': 'Save photo',
  'settings.avatarCrop.uploading': 'Uploading…',
  'settings.avatarCrop.toastWaitLoad': 'Wait for the image to load, then try again.',
  'settings.avatarCrop.toastCropFail': 'Could not crop this image. Try JPEG or PNG.',

  'agent.settings.profile.sponsorLabel': 'Sponsor agent',
  'agent.settings.profile.sponsorHelp': 'Set at registration',
  'agent.settings.profile.suspended': 'Suspended',

  'auth.gate.userTitle': 'Verifying your session',
  'auth.gate.userDescription': 'Confirming your sign-in. This only takes a moment.',
  'auth.gate.agentTitle': 'Verifying your session',
  'auth.gate.agentDescription': 'Confirming your agent sign-in. This only takes a moment.',

  'auth.page.themeLight': 'Light',
  'auth.page.themeDark': 'Dark',
  'auth.page.ariaTheme': 'Switch theme',

  'user.layout.sidebarTitle': 'MineMe User Panel',
  'user.layout.investorAccount': 'Investor account',
  'user.layout.nav.dashboard': 'Dashboard',
  'user.layout.nav.deposit': 'Deposit',
  'user.layout.nav.withdraw': 'Withdraw',
  'user.layout.nav.investments': 'Investments',
  'user.layout.nav.referral': 'Referral',
  'user.layout.nav.notifications': 'Notifications',
  'user.layout.nav.support': 'Support',
  'user.layout.nav.stopLoss': 'Stop-Loss',
  'user.layout.nav.transactions': 'Transactions',
  'user.layout.nav.settings': 'Settings',
  'user.page.support': 'Support',
  'user.support.myTickets': 'My Tickets',
  'user.support.listHint': 'Create a ticket and chat with our support team.',
  'user.support.newTicket': 'New ticket',
  'user.support.empty': 'You have no support tickets yet.',
  'user.support.loading': 'Loading…',
  'user.support.backToList': 'Back to tickets',
  'user.support.category': 'Category',
  'user.support.subject': 'Subject',
  'user.support.subjectPlaceholder': 'Short summary of your issue',
  'user.support.message': 'Message',
  'user.support.messagePlaceholder': 'Describe your issue…',
  'user.support.attachments': 'Images',
  'user.support.addImages': 'Add images',
  'user.support.removeImage': 'Remove image',
  'user.support.attachmentsHint': 'JPG, PNG, WEBP, or GIF · max 3 files · 5 MB each',
  'user.support.submit': 'Submit ticket',
  'user.support.submitting': 'Submitting…',
  'user.support.reply': 'Your reply',
  'user.support.replyPlaceholder': 'Write a reply…',
  'user.support.sendReply': 'Send reply',
  'user.support.closeTicket': 'Close ticket',
  'user.support.closing': 'Closing…',
  'user.support.closedHint': 'This ticket is closed. Create a new ticket if you still need help.',
  'user.support.roleAdmin': 'Support',
  'user.support.roleYou': 'You',
  'user.support.status.PENDING': 'Pending',
  'user.support.status.PROCESSING': 'Processing',
  'user.support.status.CLOSED': 'Closed',
  'user.support.category.Account': 'Account',
  'user.support.category.Deposit': 'Deposit',
  'user.support.category.Withdrawal': 'Withdrawal',
  'user.support.category.Investment': 'Investment',
  'user.support.category.Technical': 'Technical',
  'user.support.category.Other': 'Other',
  'user.support.toastLoadFail': 'Could not load tickets',
  'user.support.toastNeedMessage': 'Enter a message or attach an image',
  'user.support.toastCreateOk': 'Ticket created',
  'user.support.toastCreateFail': 'Could not create ticket',
  'user.support.toastReplyOk': 'Reply sent',
  'user.support.toastReplyFail': 'Could not send reply',
  'user.support.toastCloseOk': 'Ticket closed',
  'user.support.toastCloseFail': 'Could not close ticket',
  'user.layout.logout': 'Logout',
  'user.layout.balance.available': 'Available Balance',
  'user.layout.balance.frozen': 'Frozen Balance',
  'user.layout.balance.interest': 'Interest Earned Balance',
  'user.layout.balance.bonus': 'Bonus Balance',
  'user.layout.market.loading': 'Loading market data…',
  'user.layout.market.unavailable': 'Market feed unavailable',
  'user.layout.mobilePanel': 'Panel',
  'user.layout.portfolioWorkspace': 'Portfolio Workspace',

  'agent.layout.sidebarTitle': 'MineMe Agent',
  'agent.layout.role': 'Agent account',
  'agent.layout.nav.dashboard': 'Dashboard',
  'agent.layout.nav.referrals': 'Referrals',
  'agent.layout.nav.commissions': 'Commissions',
  'agent.layout.nav.team': 'My Team',
  'agent.layout.nav.transactions': 'Transactions',
  'agent.layout.nav.withdraw': 'Withdraw',
  'agent.layout.nav.notifications': 'Notifications',
  'agent.layout.nav.support': 'Support',
  'agent.layout.nav.settings': 'Settings',
  'agent.page.support': 'Support',
  'agent.support.myTickets': 'My Tickets',
  'agent.support.listHint': 'Create a ticket and chat with our support team.',
  'agent.support.newTicket': 'New ticket',
  'agent.support.empty': 'You have no support tickets yet.',
  'agent.support.loading': 'Loading…',
  'agent.support.backToList': 'Back to tickets',
  'agent.support.category': 'Category',
  'agent.support.subject': 'Subject',
  'agent.support.subjectPlaceholder': 'Short summary of your issue',
  'agent.support.message': 'Message',
  'agent.support.messagePlaceholder': 'Describe your issue…',
  'agent.support.attachments': 'Images',
  'agent.support.addImages': 'Add images',
  'agent.support.removeImage': 'Remove image',
  'agent.support.attachmentsHint': 'JPG, PNG, WEBP, or GIF · max 3 files · 5 MB each',
  'agent.support.submit': 'Submit ticket',
  'agent.support.submitting': 'Submitting…',
  'agent.support.reply': 'Your reply',
  'agent.support.replyPlaceholder': 'Write a reply…',
  'agent.support.sendReply': 'Send reply',
  'agent.support.closeTicket': 'Close ticket',
  'agent.support.closing': 'Closing…',
  'agent.support.closedHint': 'This ticket is closed. Create a new ticket if you still need help.',
  'agent.support.roleAdmin': 'Support',
  'agent.support.roleYou': 'You',
  'agent.support.status.PENDING': 'Pending',
  'agent.support.status.PROCESSING': 'Processing',
  'agent.support.status.CLOSED': 'Closed',
  'agent.support.category.Account': 'Account',
  'agent.support.category.Deposit': 'Deposit',
  'agent.support.category.Withdrawal': 'Withdrawal',
  'agent.support.category.Investment': 'Investment',
  'agent.support.category.Technical': 'Technical',
  'agent.support.category.Other': 'Other',
  'agent.support.toastLoadFail': 'Could not load tickets',
  'agent.support.toastNeedMessage': 'Enter a message or attach an image',
  'agent.support.toastCreateOk': 'Ticket created',
  'agent.support.toastCreateFail': 'Could not create ticket',
  'agent.support.toastReplyOk': 'Reply sent',
  'agent.support.toastReplyFail': 'Could not send reply',
  'agent.support.toastCloseOk': 'Ticket closed',
  'agent.support.toastCloseFail': 'Could not close ticket',
  'agent.layout.withdrawalLogs': 'Withdrawal Logs',
  'agent.layout.stats.commission': 'Commission balance',
  'agent.layout.stats.direct': 'Direct referrals',
  'agent.layout.stats.earned': 'Total earned',
  'agent.layout.workspace': 'Agent workspace',
  'agent.layout.logout': 'Logout',

  'auth.user.login.title': 'User Login',
  'auth.user.login.subtitle': 'Sign in to your user panel.',
  'auth.user.login.noAccount': "Don't have an account?",
  'auth.user.login.createAccount': 'Create Account',
  'auth.user.login.username': 'Username',
  'auth.user.login.password': 'Password',
  'auth.user.login.placeholderUsername': 'Enter your username',
  'auth.user.login.placeholderPassword': 'Enter your password',
  'auth.user.login.forgotPassword': 'Forgot password?',
  'auth.user.login.signIn': 'Sign In',
  'auth.user.login.signingIn': 'Signing in…',

  'auth.agent.login.title': 'Agent login',
  'auth.agent.login.subtitle': 'Sign in with your agent username and password.',
  'auth.agent.login.needAccount': 'Need an account?',
  'auth.agent.login.signUp': 'Sign up',
  'auth.agent.login.usernameHint':
    'Letters and numbers; hyphens are ignored (e.g. AGT-00142 works).',
  'auth.agent.login.placeholderUsername': 'Your agent username',
  'auth.agent.login.placeholderPassword': 'Enter your password',
  'auth.agent.login.forgotPassword': 'Forgot password?',
  'auth.agent.login.signIn': 'Sign In',
  'auth.agent.login.signingIn': 'Signing in…',
  'auth.agent.login.ariaShowPassword': 'Show password',
  'auth.agent.login.ariaHidePassword': 'Hide password',
  'auth.agent.login.error.usernameInvalid':
    'Use a valid username (letters, numbers, optional hyphens).',
  'auth.agent.login.error.passwordRequired': 'Password is required.',
  'auth.agent.login.error.signInFailed': 'Sign in failed',
  'auth.agent.login.success.signedIn': 'Signed in',

  'auth.user.forgot.title': 'User Forgot Password',
  'auth.user.forgot.subtitle': 'Reset your password with your 12-word recovery phrase.',
  'auth.user.forgot.remember': 'Remember your password?',
  'auth.user.forgot.signIn': 'Sign In',
  'auth.user.forgot.intro':
    'Use the same username and email as on your account, plus the phrase you saved at signup. Accounts created before recovery phrases were enabled cannot use this flow.',
  'auth.user.forgot.username': 'Username',
  'auth.user.forgot.email': 'Email',
  'auth.user.forgot.recoveryPhrase': 'Recovery phrase',
  'auth.user.forgot.recoveryPhraseLong': '12-word recovery phrase',
  'auth.user.forgot.updating': 'Updating…',
  'auth.user.forgot.needAccountSignup': 'Need an account? Sign up',
  'auth.user.forgot.newPassword': 'New password',
  'auth.user.forgot.confirmPassword': 'Confirm new password',
  'auth.user.forgot.submit': 'Reset password',
  'auth.user.forgot.submitting': 'Resetting…',
  'auth.user.forgot.placeholderUsername': 'Your username',
  'auth.user.forgot.placeholderEmail': 'Your account email',
  'auth.user.forgot.placeholderRecovery': 'Enter your 12-word phrase',
  'auth.user.forgot.placeholderNew': 'At least 8 characters',
  'auth.user.forgot.placeholderConfirm': 'Repeat new password',
  'auth.user.forgot.error.usernameRequired': 'Username is required.',
  'auth.user.forgot.error.emailRequired': 'Email is required.',
  'auth.user.forgot.error.recoveryRequired': 'Recovery phrase is required.',
  'auth.user.forgot.error.newPasswordRequired': 'New password is required.',
  'auth.user.forgot.error.newPasswordMin': 'New password must be at least 8 characters.',
  'auth.user.forgot.error.passwordsMismatch': 'New password and confirmation do not match.',
  'auth.user.forgot.error.recoveryFailed': 'Recovery failed',
  'auth.user.forgot.success.passwordUpdated': 'Password updated — you can sign in',

  'auth.agent.forgot.title': 'Agent forgot password',
  'auth.agent.forgot.subtitle': 'Reset your password with your 12-word recovery phrase.',
  'auth.agent.forgot.remember': 'Remember your password?',
  'auth.agent.forgot.signIn': 'Sign in',
  'auth.agent.forgot.intro':
    'Use the same username and email as on your account, plus the phrase you saved at signup.',
  'auth.agent.forgot.placeholderUsername': 'Your agent username',

  'common.time.days': 'Days',
  'common.time.hours': 'Hours',
  'common.time.minutes': 'Minutes',
  'common.time.seconds': 'Seconds',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.submitting': 'Submitting…',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.max': 'MAX',
  'common.copyValue': 'Copy value',
  'common.copied': 'Copied!',
  'common.dismissNotification': 'Dismiss notification',
  'common.ariaSelectLanguage': 'Select language',

  'user.dashboard.title': 'Dashboard',
  'user.dashboard.loadingInvestments': 'Loading investment status…',
  'user.dashboard.vouchers.title': 'Your E-Vouchers',
  'user.dashboard.vouchers.hint':
    'Approved E-Voucher withdrawals appear here with code and PIN. Share them so another user can redeem on Deposit → E-Voucher.',
  'user.dashboard.vouchers.loading': 'Loading your vouchers…',
  'user.withdraw.detail.voucherSection': 'E-Voucher details',

  'user.dashboard.balance.available': 'Available Balance',
  'user.dashboard.balance.frozen': 'Frozen Balance',
  'user.dashboard.balance.interest': 'Interest Earned',
  'user.dashboard.balance.bonus': 'Bonus Balance',

  'user.dashboard.stats.totalInvested': 'Total Invested',
  'user.dashboard.stats.netPnl': 'Net Profit / Loss',
  'user.dashboard.stats.activePlans': 'Active Plans',

  'user.dashboard.noInvestment.title': 'No Active Investment',
  'user.dashboard.noInvestment.subtitle': 'Start investing today and grow your wealth with high-yield returns',
  'user.dashboard.noInvestment.cta': 'Explore Investment Plans',

  'user.dashboard.recentTx.title': 'Recent Transactions',
  'user.dashboard.recentTx.viewAll': 'View All',
  'user.dashboard.recentTx.col.date': 'Date',
  'user.dashboard.recentTx.col.type': 'Type',
  'user.dashboard.recentTx.col.description': 'Description',
  'user.dashboard.recentTx.col.amount': 'Amount',
  'user.dashboard.recentTx.col.status': 'Status',
  'user.dashboard.recentTx.loading': 'Loading recent transactions…',
  'user.dashboard.recentTx.empty': 'No recent transactions found.',

  'user.dashboard.tx.Deposit': 'Deposit',
  'user.dashboard.tx.Investment': 'Investment',
  'user.dashboard.tx.Referral': 'Referral',
  'user.dashboard.tx.Bonus': 'Bonus',
  'user.dashboard.tx.Withdrawal': 'Withdrawal',
  'user.dashboard.tx.E-Voucher': 'E-Voucher',
  'user.dashboard.tx.Stop-Loss': 'Stop-Loss',

  'user.dashboard.st.Completed': 'Completed',
  'user.dashboard.st.Active': 'Active',
  'user.dashboard.st.Pending': 'Pending',
  'user.dashboard.st.Failed': 'Failed',

  'user.dashboard.invest.planFallback': 'Plan',
  'user.dashboard.invest.activeBadge': 'Active',
  'user.dashboard.invest.detail.amountInvested': 'Amount Invested',
  'user.dashboard.invest.detail.currentValue': 'Current Value',
  'user.dashboard.invest.detail.pl': 'P/L',
  'user.dashboard.invest.detail.interestRate': 'Interest Rate',
  'user.dashboard.invest.detail.perMonth': '{{pct}}% / month',
  'user.dashboard.invest.detail.perDay': '{{pct}}% / day',
  'user.dashboard.invest.detail.duration': 'Duration',
  'user.dashboard.invest.detail.months': '{{n}} Months',
  'user.dashboard.invest.detail.startDate': 'Start Date',
  'user.dashboard.invest.detail.nextWithdrawal': 'Next Withdrawal',
  'user.dashboard.invest.countdownTitle': 'Next Withdrawal In',
  'user.dashboard.invest.progress': 'Progress',
  'user.dashboard.invest.progressPct': '{{pct}}% complete',
  'user.dashboard.invest.earlyWithdraw': 'Early Withdraw',
  'user.dashboard.invest.planChip': '{{name}} #{{num}}',

  'user.dashboard.invest.modal.title': 'Early Withdrawal Warning',
  'user.dashboard.invest.modal.investmentAmount': 'Investment Amount:',
  'user.dashboard.invest.modal.platformFee': 'Platform Fee ({{pct}}%):',
  'user.dashboard.invest.modal.interestForfeited': 'Interest Forfeited:',
  'user.dashboard.invest.modal.youWillReceive': 'You Will Receive:',
  'user.dashboard.invest.modal.confirmHint': 'Type "CONFIRM" to proceed',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': 'Confirm Withdrawal',
  'user.dashboard.invest.modal.cancelling': 'Cancelling…',
  'user.dashboard.invest.toast.cancelled': 'Investment cancelled',
  'user.dashboard.invest.toast.cancelFailed': 'Cancel failed',

  'notifications.bell.triggerAria': 'Notifications',
  'notifications.bell.title': 'Notifications',
  'notifications.bell.loading': 'Loading…',
  'notifications.bell.loadErrorSubtitle': 'Could not load notifications',
  'notifications.bell.unreadOne': '1 unread update',
  'notifications.bell.unreadMany': '{{count}} unread updates',
  'notifications.bell.allCaughtUp': "You're all caught up",
  'notifications.bell.markAllRead': 'Mark all read',
  'notifications.bell.empty': 'No notifications yet',
  'notifications.bell.emptyError': "Couldn't load notifications",
  'notifications.bell.viewAll': 'View all',
  'notifications.bell.markReadAria': 'Mark as read',
  'notifications.bell.time.justNow': 'just now',
  'notifications.bell.time.secondsAgo': '{{n}}s ago',
  'notifications.bell.time.minutesAgo': '{{n}}m ago',
  'notifications.bell.time.hoursAgo': '{{n}}h ago',
  'notifications.bell.time.daysAgo': '{{n}}d ago',

  'user.socialProof.network': 'USDT (TRC20)',
  'user.socialProof.label': 'Withdrawal',
  'user.socialProof.withdrew': 'Successfully withdrew {{amount}} via {{network}}',
  'user.socialProof.time.justNow': 'just now',
  'user.socialProof.time.sec30': '30 sec ago',
  'user.socialProof.time.min1': '1 min ago',
  'user.socialProof.time.min2': '2 mins ago',
  'user.socialProof.time.min3': '3 mins ago',

  'user.deposit.title': 'Deposit',
  'user.deposit.tab.crypto': 'Crypto Deposit',
  'user.deposit.tab.evoucher': 'E-Voucher',

  'user.deposit.network.trc20': 'USDT TRC20',
  'user.deposit.network.erc20': 'USDT ERC20',
  'user.deposit.network.btc': 'BTC',
  'user.deposit.network.eth': 'ETH',
  'user.deposit.network.label': 'Network',
  'user.deposit.network.soon': 'Coming Soon',

  'user.deposit.crypto.loadAddressFailed': 'Failed to load deposit address',
  'user.deposit.crypto.genericError': 'Something went wrong',
  'user.deposit.crypto.loadingAddress': 'Loading deposit address…',
  'user.deposit.crypto.checking': 'Checking…',
  'user.deposit.crypto.checkForDeposit': 'Check for Deposit',
  'user.deposit.crypto.checkFound': 'New deposit detected! Awaiting confirmations.',
  'user.deposit.crypto.checkNone': 'No new deposits found. Check again in a moment.',
  'user.deposit.crypto.checkFailed': 'Check failed',
  'user.deposit.crypto.networkError': 'Network error',

  'user.deposit.card.title': 'Your Deposit Address',
  'user.deposit.card.sendOnly': 'Send USDT TRC20 only to this address',
  'user.deposit.card.networkLine': 'Network: USDT TRC20 only',
  'user.deposit.card.confirmationsLine': '{{n}} confirmations required (~1 min)',
  'user.deposit.card.valid24h': 'Address valid for 24 hours',
  'user.deposit.card.warningWrongToken':
    'Only send USDT TRC20. Sending any other token or network will result in permanent loss of funds.',
  'user.deposit.card.scanQr': 'Scan QR Code',
  'user.deposit.card.qrCaption': 'USDT TRC20',
  'user.deposit.expired': 'Expired',
  'user.deposit.expiresIn': 'Expires in {{h}}h {{m}}m {{s}}s',

  'user.deposit.bonus.title': 'Deposit bonus',
  'user.deposit.bonus.subtitle': 'Extra balance on qualifying USDT deposits and e-voucher redemptions.',
  'user.deposit.bonus.tierLine': '{{min}} or more → {{percent}}% extra',
  'user.deposit.bonus.preview': '{{amount}} deposit → {{bonus}} bonus',

  'user.deposit.history.title': 'Deposit History',
  'user.deposit.history.filter.all': 'All',
  'user.deposit.history.filter.pending': 'Pending',
  'user.deposit.history.filter.confirming': 'Confirming',
  'user.deposit.history.filter.completed': 'Completed',
  'user.deposit.history.filter.failed': 'Failed',
  'user.deposit.history.col.date': 'Date',
  'user.deposit.history.col.amount': 'Amount',
  'user.deposit.history.col.bonus': 'Bonus',
  'user.deposit.history.col.status': 'Status',
  'user.deposit.history.col.confirmations': 'Confirmations',
  'user.deposit.history.col.txid': 'TXID',
  'user.deposit.history.emptyTitle': 'No Deposits Yet',
  'user.deposit.history.emptyDesc': 'Your deposit history will appear here',
  'user.deposit.history.ariaLoading': 'Loading deposit history',
  'user.deposit.history.ariaTronscan': 'View on TronScan',
  'user.deposit.history.pageOf': 'Page {{current}} of {{total}}',

  'user.deposit.depStatus.pending': 'Pending',
  'user.deposit.depStatus.confirming': 'Confirming',
  'user.deposit.depStatus.completed': 'Completed',
  'user.deposit.depStatus.failed': 'Failed',

  'user.deposit.voucher.redeemTitle': 'Redeem E-Voucher',
  'user.deposit.voucher.generateTitle': 'Generate E-Voucher',
  'user.deposit.voucher.code': 'Voucher Code',
  'user.deposit.voucher.pin': '4-Digit PIN',
  'user.deposit.voucher.copyPinLabel': 'PIN',
  'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
  'user.deposit.voucher.placeholderPin': '••••',
  'user.deposit.voucher.placeholderAmount': '0.00',
  'user.deposit.voucher.redeem': 'Redeem Voucher',
  'user.deposit.voucher.redeeming': 'Redeeming…',
  'user.deposit.voucher.convertHint': 'Convert your balance into a transferable voucher',
  'user.deposit.voucher.amountLabel': 'Amount to Convert',
  'user.deposit.voucher.availableBalance': 'Available Balance: {{amount}}',
  'user.deposit.voucher.availableLineLoading': 'Available Balance: Loading…',
  'user.deposit.voucher.generate': 'Generate Voucher',
  'user.deposit.voucher.generating': 'Generating…',
  'user.deposit.voucher.yourVoucher': 'Your E-Voucher',
  'user.deposit.voucher.copyAll': 'Copy All Details',
  'user.deposit.voucher.warnOnce': 'This voucher can only be redeemed once. Keep it safe.',
  'user.deposit.voucher.statusActive': 'Active',
  'user.deposit.voucher.statusUsed': 'Used',
  'user.deposit.voucher.usedNote': 'This voucher was already redeemed.',
  'user.deposit.voucher.myIssuedTitle': 'My issued vouchers',
  'user.deposit.voucher.emptyIssued': 'You have not issued any vouchers yet.',
  'user.deposit.voucher.loadingIssued': 'Loading your vouchers…',
  'user.deposit.voucher.pinOnceHint':
    'PIN was shown once when you generated this voucher. Share from your saved copy.',
  'user.deposit.voucher.clipboard': 'Voucher Code: {{code}}\nPIN: {{pin}}',
  'user.deposit.voucher.toastValidAmount': 'Enter a valid amount.',
  'user.deposit.voucher.toastCodePin': 'Enter a valid 12-char code and 4-digit PIN.',
  'user.deposit.voucher.toastGenFail': 'Failed to generate voucher.',
  'user.deposit.voucher.toastRedeemFail': 'Failed to redeem voucher.',
  'user.deposit.voucher.toastGenOk': 'Voucher generated successfully.',
  'user.deposit.voucher.toastCopied': 'Voucher details copied.',
  'user.deposit.voucher.toastRedeemed': 'Voucher redeemed. {{amount}} added.',
  'user.deposit.voucher.toastRedeemedWithBonus':
    'Voucher redeemed. {{amount}} + {{bonus}} bonus ({{percent}}%) added.',

  'user.withdraw.title': 'Withdraw',
  'user.withdraw.form.title': 'Request Withdrawal',
  'user.withdraw.form.method': 'Withdrawal Method',
  'user.withdraw.form.selectMethod': 'Select method',
  'user.withdraw.form.walletAddress': 'Wallet Address',
  'user.withdraw.form.walletPlaceholder': 'Enter your USDT wallet address',
  'user.withdraw.form.walletPlaceholderBep20': 'Enter your BEP20 USDT address (0x…)',
  'user.withdraw.form.amount': 'Amount (USD)',
  'user.withdraw.form.available': 'Available Balance:',
  'user.withdraw.form.minAmount': 'Minimum withdrawal: {{amount}}',
  'user.withdraw.form.maxAmount': 'Maximum withdrawal: {{amount}}',
  'user.withdraw.form.weekendOnlyHint':
    'Wallet withdrawals are available on Saturday and Sunday only (your local time). Early plan cancellation is not affected.',
  'user.withdraw.form.feeTitle': 'Wallet withdrawal fee: {{pct}}%',
  'user.withdraw.form.feeBody':
    'A {{pct}}% platform fee is deducted from your withdrawal amount. Early plan cancellation uses a separate fee.',
  'user.withdraw.form.noFeeTitle': 'No platform fee',
  'user.withdraw.form.noFeeBody':
    'Wallet withdrawals have no platform fee. Early plan cancellation uses a separate fee.',
  'user.withdraw.form.loadingBalance': 'Loading…',
  'user.withdraw.form.placeholderAmount': '0.00',
  'user.withdraw.form.summaryAmount': 'Withdrawal Amount',
  'user.withdraw.form.summaryFee': 'Platform Fee',
  'user.withdraw.form.noFee': 'No fee',
  'user.withdraw.form.youReceive': 'You Will Receive',
  'user.withdraw.form.request': 'Request Withdrawal',
  'user.withdraw.form.method.trc20': 'USDT TRC20',
  'user.withdraw.form.method.bep20': 'USDT BEP20',
  'user.withdraw.form.method.erc20': 'USDT ERC20',
  'user.withdraw.form.method.evoucher': 'E-Voucher',
  'user.withdraw.toast.minUsd': 'Minimum withdrawal is {{amount}}',
  'user.withdraw.toast.maxUsd': 'Maximum withdrawal is {{amount}}',
  'user.withdraw.toast.weekendOnly':
    'Wallet withdrawals are only available on Saturday and Sunday in your local time.',
  'user.withdraw.toast.tooLowAfterFee': 'Withdrawal amount is too low after the platform fee',
  'user.withdraw.toast.insufficient': 'Insufficient balance',
  'user.withdraw.toast.walletRequired': 'Wallet address is required',
  'user.withdraw.toast.submitFail': 'Failed to submit withdrawal',
  'user.withdraw.toast.submitted': 'Withdrawal request submitted',

  'user.withdraw.modal.title': 'Confirm Withdrawal',
  'user.withdraw.modal.submitting': 'Submitting…',

  'user.withdraw.rules.title': 'Withdrawal Rules',
  'user.withdraw.rules.cryptoMining': 'Crypto Mining',
  'user.withdraw.rules.cryptoMiningPeriod': 'Every 3 months',
  'user.withdraw.rules.bullion': 'Bullion Trade',
  'user.withdraw.rules.bullionPeriod': 'Every 8 months',
  'user.withdraw.rules.pharma': 'Pharmaceuticals',
  'user.withdraw.rules.pharmaPeriod': 'End of plan period',
  'user.withdraw.rules.supported': 'Supported Methods',
  'user.withdraw.rules.feeNote':
    'A {{pct}}% platform fee applies to wallet withdrawals. Early plan cancellation uses a separate fee.',
  'user.withdraw.rules.noFeeNote':
    'No platform fee on wallet withdrawals. Early plan cancellation uses a separate fee.',
  'user.withdraw.rules.processingNote':
    'Withdrawal requests are processed within 24-48 hours after approval.',

  'user.withdraw.history.title': 'Withdrawal History',
  'user.withdraw.history.exportCsv': 'Export CSV',
  'user.withdraw.history.empty': 'No withdrawals yet. Your withdrawal history will appear here.',
  'user.withdraw.history.col.date': 'Date',
  'user.withdraw.history.col.amount': 'Amount',
  'user.withdraw.history.col.method': 'Method',
  'user.withdraw.history.col.fee': 'Fee',
  'user.withdraw.history.col.net': 'Net Amount',
  'user.withdraw.history.col.status': 'Status',
  'user.withdraw.history.col.txid': 'TXID',
  'user.withdraw.history.col.actions': 'Actions',
  'user.withdraw.history.ariaViewDetails': 'View withdrawal details',
  'user.withdraw.history.ariaCopyTxid': 'Copy TXID',

  'user.withdraw.detail.title': 'Withdrawal Details',
  'user.withdraw.detail.requestId': 'Request ID',
  'user.withdraw.detail.date': 'Date',
  'user.withdraw.detail.method': 'Method',
  'user.withdraw.detail.amount': 'Amount',
  'user.withdraw.detail.fee': 'Fee',
  'user.withdraw.detail.net': 'Net Amount',
  'user.withdraw.detail.status': 'Status',
  'user.withdraw.detail.wallet': 'Wallet',
  'user.withdraw.detail.rejectReason': 'Reject Reason:',

  'user.withdraw.st.Pending': 'Pending',
  'user.withdraw.st.Completed': 'Completed',
  'user.withdraw.st.Rejected': 'Rejected',
  'user.withdraw.st.Approved': 'Approved',

  'user.withdraw.csv.date': 'Date',
  'user.withdraw.csv.amount': 'Amount',
  'user.withdraw.csv.method': 'Method',
  'user.withdraw.csv.fee': 'Fee',
  'user.withdraw.csv.net': 'Net Amount',
  'user.withdraw.csv.status': 'Status',
  'user.withdraw.csv.txid': 'TXID',

  'user.notifications.title': 'Notifications',

  'inbox.summary': '{{total}} total · {{unread}} unread',
  'inbox.loadingSummary': 'Loading…',
  'inbox.refresh': 'Refresh',
  'inbox.refreshAria': 'Refresh notifications',
  'inbox.markAllRead': 'Mark all read',
  'inbox.loadingList': 'Loading notifications…',
  'inbox.empty': 'No notifications yet.',
  'inbox.openRelated': 'Open related page →',
  'inbox.markReadAria': 'Mark as read',
  'inbox.removeAria': 'Remove',
  'inbox.pageOf': 'Page {{current}} / {{total}}',
  'inbox.time.justNow': 'just now',
  'inbox.time.secAgo': '{{sec}}s ago',
  'inbox.time.minAgo': '{{min}}m ago',
  'inbox.time.hrAgo': '{{hr}}h ago',

  'user.page.investments': 'Investments',
  'user.page.transactions': 'Transactions',
  'user.page.stopLoss': 'Stop-Loss',
  'user.page.referral': 'Referral',
  'user.page.settings': 'Settings',
  'user.page.deposit': 'Deposit',
  'user.page.withdraw': 'Withdraw',

  'user.signup.title': 'User sign up',
  'user.signup.subtitle': 'Create your user panel account.',
  'user.signup.secondaryText': 'Already have an account?',
  'user.signup.secondaryLabel': 'Sign In',
  'user.signup.toastCreated': 'Account created — you can sign in now.',
  'user.signup.toastSaveRecoveryFirst':
    'Account created — save your recovery phrase before continuing',
  'user.signup.error.nameRequired': 'Full name is required.',
  'user.signup.error.usernameAlphanumeric': 'Username must contain only letters and numbers.',
  'user.signup.error.usernameMin': 'Username must be at least {{min}} characters.',
  'user.signup.error.usernameMax': 'Username must be at most {{max}} characters.',
  'user.signup.error.usernameTaken': 'This username is already taken.',
  'user.signup.error.usernameCheckWait': 'Please wait for the username check to finish.',
  'user.signup.error.emailRequired': 'Email is required.',
  'user.signup.error.passwordRequired': 'Password is mandatory.',
  'user.signup.error.confirmRequired': 'Confirm password is mandatory.',
  'user.signup.error.passwordsMismatch': 'Passwords do not match.',
  'user.signup.error.passwordMin': 'Password must be at least 8 characters.',
  'user.signup.error.captchaWrong': 'Captcha is mandatory and must be correct.',
  'user.signup.error.referralRequired': 'Referral ID is required.',
  'user.signup.error.referralInvalid': 'Referral ID must contain only letters and numbers.',
  'user.signup.error.registrationFailed': 'Registration failed',
  'user.signup.form.labelFullName': 'Full name',
  'user.signup.form.placeholderFullName': 'Your full name',
  'user.signup.form.labelUsername': 'Username',
  'user.signup.form.placeholderUsername': 'Create username',
  'user.signup.form.usernameHint': '{{min}}–{{max}} characters, letters and numbers only.',
  'user.signup.form.labelEmail': 'Email',
  'user.signup.form.placeholderEmail': 'Enter email',
  'user.signup.form.labelPhone': 'Phone number (optional)',
  'user.signup.form.placeholderPhone': '+1… or digits only',
  'user.signup.form.labelReferral': 'Referral ID (required)',
  'user.signup.form.placeholderReferral': 'Referrer username',
  'user.signup.form.referralHint':
    'Enter a user or agent username. Users can refer users; agents can refer users.',
  'user.signup.form.labelPassword': 'Password (mandatory)',
  'user.signup.form.placeholderPassword': 'Create password',
  'user.signup.form.labelConfirmPassword': 'Confirm Password (mandatory)',
  'user.signup.form.placeholderConfirmPassword': 'Confirm password',
  'user.signup.form.captchaRobot': "I'm not a robot (mandatory)",
  'user.signup.form.captchaQuestion': 'Captcha: What is {{a}} + {{b}}?',
  'user.signup.form.placeholderCaptcha': 'Enter captcha answer',
  'user.signup.form.submitting': 'Creating…',
  'user.signup.form.submit': 'Create Account',
  'user.signup.username.available': 'This username is available.',
  'user.signup.username.taken': 'This username is already taken.',
  'user.signup.username.invalidChars': 'Use only letters and numbers (no spaces).',
  'user.signup.username.invalidMin': 'Username must be at least {{min}} characters.',
  'user.signup.username.invalidGeneric': 'This username cannot be used.',
  'user.signup.recovery.title': 'Save your recovery phrase',
  'user.signup.recovery.body':
    'This is the only time we can show it. Write it down and store it offline. You will need it to reset your password if you forget it.',
  'user.signup.recovery.warn':
    'Never share this phrase. Anyone with it can reset your password.',
  'user.signup.recovery.copy': 'Copy phrase',
  'user.signup.recovery.copiedToast': 'Phrase copied',
  'user.signup.recovery.checkbox':
    'I have written down or securely saved my 12-word recovery phrase.',
  'user.signup.recovery.continue': 'Continue to sign in',
  'user.profile.cropPhotoTitle': 'Crop profile photo',

  'user.empty.noActiveInvestments': 'No active investments',
  'user.empty.noTransactions': 'No transactions found',
  'user.empty.noTransactionsHint': 'Try adjusting your filters.',
  'user.empty.noStopLoss': 'No active Stop-Loss protection',

  'user.investments.loadingActive': 'Loading active investments…',
  'user.investments.loadFailed': 'Failed to load active investments',
  'user.investments.emptyTitle': 'No active investments',
  'user.investments.emptyDesc': 'Browse and invest in a plan to get started',
  'user.investments.browsePlans': 'Browse plans',

  'user.investments.tab.browse': 'Browse plans',
  'user.investments.tab.active': 'Active investments',
  'user.investments.tab.history': 'History',

  'user.investments.plan.compound': 'Compound interest',
  'user.investments.plan.simple': 'Simple interest',

  'user.investments.card.minPrincipal': 'Min principal',
  'user.investments.card.maxPrincipal': 'Max principal',
  'user.investments.card.interestRate': 'Interest rate',
  'user.investments.card.dailyProfit': 'Daily profit',
  'user.investments.card.earningDays': 'Earning days',
  'user.investments.card.earningDaysValue': '{{count}} business days',
  'user.investments.card.duration': 'Duration',
  'user.investments.card.durationMonths': '{{n}} months',
  'user.investments.duration.oneDay': '1 day',
  'user.investments.duration.daysOnly': '{{days}} days',
  'user.investments.duration.oneMonth': '1 month',
  'user.investments.duration.monthsOnly': '{{months}} months',
  'user.investments.duration.daysAndMonths': '{{months}} months {{days}} days',
  'user.investments.card.interestType': 'Interest type',
  'user.investments.card.expectedProfit': 'Expected profit',
  'user.investments.card.totalReturn': 'Total return',
  'user.investments.card.comingSoonLine': 'Coming soon',
  'user.investments.card.launchingSoon': 'Launching soon — stay tuned',
  'user.investments.card.comingSoonBadge': 'Coming soon',
  'user.investments.card.notAvailable': 'Not available',
  'user.investments.card.investNow': 'Invest now',
  'user.investments.card.investLimit': 'Invest limit',
  'user.investments.card.investLimitLine': '{{count}}× in {{days}} days',
  'user.investments.card.investLimitReached':
    'You have reached the investment limit for this plan in the current period.',
  'user.investments.card.limitReached': 'Limit reached',

  'user.investments.history.title': 'Investment history',
  'user.investments.history.loading': 'Loading history…',
  'user.investments.history.empty': 'No investment history yet.',
  'user.investments.history.col.plan': 'Plan',
  'user.investments.history.col.amount': 'Amount invested',
  'user.investments.history.col.rate': 'Interest rate',
  'user.investments.history.col.duration': 'Duration',
  'user.investments.history.col.returns': 'Returns earned',
  'user.investments.history.col.endDate': 'End date',
  'user.investments.history.col.status': 'Status',
  'user.investments.history.months': '{{n}} months',
  'user.investments.history.rateMo': '{{pct}}%/mo',
  'user.investments.history.rateTerm': '{{pct}}%',
  'user.investments.history.rateDay': '{{pct}}%/day',
  'user.investments.history.st.active': 'Active',
  'user.investments.history.st.cancelled': 'Cancelled',
  'user.investments.history.st.completed': 'Completed',
  'user.investments.history.st.pending': 'Pending',

  'user.investments.modal.amountLabel': 'Amount (USD)',
  'user.investments.modal.placeholderAmount': 'Enter amount',
  'user.investments.modal.minMax': 'Min: {{min}} · Max: {{max}}',
  'user.investments.modal.available': 'Available balance: {{amount}}',
  'user.investments.modal.availableLoading': 'Available balance: Loading…',
  'user.investments.modal.errMin': 'Minimum investment is {{min}}',
  'user.investments.modal.errMax': 'Maximum investment is {{max}}',
  'user.investments.modal.errInsufficient': 'Insufficient balance. You need {{amount}} but only have {{available}}.',
  'user.investments.modal.toastInsufficient': 'Insufficient balance. Please deposit first.',
  'user.investments.modal.projectedTitle': 'Projected returns',
  'user.investments.modal.periodInterestTerm': 'Plan interest',
  'user.investments.modal.periodInterestDay': 'Daily interest',
  'user.investments.modal.periodInterestYear': 'Monthly equivalent',
  'user.investments.modal.monthlyInterest': 'Monthly interest',
  'user.investments.modal.totalInterest': 'Total interest',
  'user.investments.modal.totalWithdrawal': 'Total withdrawal',
  'user.investments.modal.periodHoursOnly': '{{hours}} hours',
  'user.investments.modal.periodDaysOnly': '{{days}} days',
  'user.investments.modal.periodDaysHours': '{{days}} days {{hours}} hours',
  'user.investments.modal.hintPlanChange':
    'Plan change allowed within {{period}} of selection',
  'user.investments.modal.hintCancellation':
    'Investment can be cancelled within the first {{period}}',
  'user.investments.modal.hintWeekdayOnly':
    'Interest is credited to available balance on weekdays only',
  'user.investments.modal.toastWeekdayOnly':
    'Plan subscriptions are only available Monday through Friday in your timezone.',
  'user.investments.modal.submit': 'Confirm investment',
  'user.investments.modal.submitting': 'Processing…',
  'user.investments.modal.toastInvalidAmount': 'Please enter a valid amount.',
  'user.investments.modal.toastSubscribeFail': 'Failed to subscribe',
  'user.investments.modal.toastSubscribeOk': 'Investment subscribed successfully',

  'user.referral.link.title': 'Your referral link',
  'user.referral.link.loading': 'Loading link…',
  'user.referral.link.hint': 'Invite friends to MineMe with your personal link.',
  'user.referral.link.hintLong':
    'Invite friends to MineMe with your personal link and help grow the network.',
  'user.referral.link.share': 'Share',
  'user.referral.link.shareTitle': 'Join with my referral link',
  'user.referral.stats.direct': 'Direct referrals',
  'user.referral.stats.indirect': 'Indirect referrals',
  'user.referral.stats.directRate': 'Level 1 commission',
  'user.referral.stats.indirectRate': 'Level 2 commission',
  'user.referral.stats.rateValue': '{{pct}}% on investment',
  'user.referral.stats.earnings': 'Referral earnings',
  'user.referral.tree.title': 'Your referral network',
  'user.referral.tree.loading': 'Loading network…',
  'user.referral.tree.you': 'You',
  'user.referral.tree.directLevel': 'Direct level',
  'user.referral.tree.indirectLevel': 'Indirect level',
  'user.referral.tree.noDirect': 'No direct referrals yet',
  'user.referral.tree.noIndirect': 'No indirect referrals yet',
  'user.referral.tree.directCount': '{{n}} direct referrals',
  'user.referral.tree.indirectCount': '{{n}} indirect referrals',
  'user.referral.tree.more': '+{{n}} more',

  'user.referral.ranking.tableTitle': 'Ranking system',
  'user.referral.ranking.loading': 'Loading rankings…',
  'user.referral.ranking.loadError': 'Rankings could not be loaded. Refresh the page or try again later.',
  'user.referral.ranking.col.rank': 'Rank',
  'user.referral.ranking.col.minDeposit': 'Min deposit',
  'user.referral.ranking.col.monthlyIncome': 'Monthly income',
  'user.referral.ranking.col.directRefs': 'Direct refs',
  'user.referral.ranking.col.extraCommission': 'Extra commission',
  'user.referral.ranking.badgeYou': 'You',

  'user.referral.rankingRewards.title': 'Ranking rewards',
  'user.referral.rankingRewards.loading': 'Loading ranking progress…',
  'user.referral.rankingRewards.engineDisabled':
    'The ranking rewards engine is currently disabled by the administrator.',
  'user.referral.rankingRewards.notInScope':
    'Ranking rewards are not available for your account type per the current platform settings.',
  'user.referral.rankingRewards.disqualified':
    'Your {{days}}-day activation window expired before you reached the entry tier, so future ranking rewards are no longer available.',
  'user.referral.rankingRewards.daysLeftOne': '{{days}} day left to activate',
  'user.referral.rankingRewards.daysLeftMany': '{{days}} days left to activate',
  'user.referral.rankingRewards.activationClosingToday': 'Activation window closing today',
  'user.referral.rankingRewards.activationHint':
    'Reach the entry tier within {{days}} days of registration (deadline {{deadline}}). Day 1 starts the moment you sign up. Both direct AND indirect criteria must be met.',
  'user.referral.rankingRewards.activatedBanner':
    'Activated. Keep recruiting to unlock higher tiers — each is awarded one time when both direct and indirect criteria are met.',
  'user.referral.rankingRewards.windowBadge': '{{days}}-day window',
  'user.referral.rankingRewards.earnedSummary': 'Earned {{amount}} across {{count}} tier',
  'user.referral.rankingRewards.earnedSummaryPlural': 'Earned {{amount}} across {{count}} tiers',
  'user.referral.rankingRewards.col.tier': 'Tier',
  'user.referral.rankingRewards.col.reward': 'Reward',
  'user.referral.rankingRewards.col.awarded': 'Awarded',

  'user.referral.currentRank.minDeposit': '· {{amount}} min deposit',
  'user.referral.currentRank.title': 'Current rank',
  'user.referral.currentRank.loading': 'Loading your rank…',
  'user.referral.currentRank.topRank': 'Top rank',
  'user.referral.currentRank.targets': '{{rank}} targets',
  'user.referral.currentRank.topCongratulations': 'You are at the top rank — congratulations.',
  'user.referral.currentRank.directMore': '{{n}} direct more',
  'user.referral.currentRank.directMorePlural': '{{n}} directs more',
  'user.referral.currentRank.indirectMore': '{{n}} indirect more',
  'user.referral.currentRank.indirectMorePlural': '{{n}} indirects more',
  'user.referral.currentRank.readyUnlock': 'Ready to unlock {{rank}} on the next evaluation.',
  'user.referral.currentRank.remainingJoin': '{{parts}} to reach {{rank}}.',
  'user.referral.currentRank.noTiers': 'No rank tiers configured',
  'user.referral.currentRank.pillTop': 'Active — Top rank reached',
  'user.referral.currentRank.pillActive': 'Active',
  'user.referral.currentRank.pillStarter': 'Starter rank — meet targets to earn the tier reward',
  'user.referral.currentRank.lastReward': 'Last tier reward earned:',
  'user.referral.currentRank.bonusHeading': '{{rank}} bonus',
  'user.referral.currentRank.progressLine':
    '{{directHave}}/{{directNeed}} direct · {{indirectHave}}/{{indirectNeed}} indirect',

  'user.transactions.sectionTitle': 'Transaction history',
  'user.transactions.loading': 'Loading transactions…',
  'user.transactions.emptyTitle': 'No transactions found',
  'user.transactions.emptyHint': 'Try adjusting your filters',
  'user.transactions.col.date': 'Date & time',
  'user.transactions.col.type': 'Type',
  'user.transactions.col.description': 'Description',
  'user.transactions.col.amount': 'Amount',
  'user.transactions.col.status': 'Status',
  'user.transactions.col.txid': 'TXID',
  'user.transactions.showing': 'Showing {{from}}–{{to}} of {{total}} transactions',

  'user.transactions.filter.from': 'From',
  'user.transactions.filter.to': 'To',
  'user.transactions.filter.searchPlaceholder': 'Search TXID or description…',
  'user.transactions.filter.all': 'All',
  'user.transactions.filter.deposit': 'Deposit',
  'user.transactions.filter.withdrawal': 'Withdrawal',
  'user.transactions.filter.investment': 'Investment',
  'user.transactions.filter.evoucher': 'E-Voucher',
  'user.transactions.filter.referral': 'Referral',
  'user.transactions.filter.stopLoss': 'Stop-Loss',

  'user.transactions.badge.deposit': 'Deposit',
  'user.transactions.badge.withdrawal': 'Withdrawal',
  'user.transactions.badge.investment': 'Investment',
  'user.transactions.badge.e-voucher': 'E-Voucher',
  'user.transactions.badge.referral': 'Referral',
  'user.transactions.badge.bonus': 'Bonus',
  'user.transactions.badge.stop-loss': 'Stop-Loss',
  'user.transactions.badge.completed': 'Completed',
  'user.transactions.badge.active': 'Active',
  'user.transactions.badge.pending': 'Pending',
  'user.transactions.badge.confirming': 'Confirming',
  'user.transactions.badge.approved': 'Approved',
  'user.transactions.badge.cancelled': 'Cancelled',
  'user.transactions.badge.rejected': 'Rejected',
  'user.transactions.badge.failed': 'Failed',
  'user.transactions.exportCsv': 'Export CSV',
  'user.transactions.exportCsvTitle': 'Export as CSV',
  'user.transactions.exportNoData': 'No data to export',

  'user.stopLoss.yourProtection': 'Your active protection',
  'user.stopLoss.activePackages': 'Active Stop-Loss packages',
  'user.stopLoss.live': 'Live',
  'user.stopLoss.subtitleOne': '1 package is currently shielding your portfolio.',
  'user.stopLoss.subtitleMany': '{{n}} packages are currently active.',
  'user.stopLoss.loadingTable': 'Loading…',
  /** Non-English: mirror in `partials/panelStopLossFlowI18n.js` */
  'user.stopLoss.emptyDescNoSlots': 'Protect an active investment below (one stop-loss per plan).',
  'user.stopLoss.emptyDescWaiting': 'You have {{count}} purchased slot(s) waiting for assignment.',
  'user.stopLoss.col.package': 'Package',
  'user.stopLoss.col.amountPaid': 'Amount paid',
  'user.stopLoss.col.premium': 'Premium %',
  'user.stopLoss.col.datePurchased': 'Date purchased',
  'user.stopLoss.col.status': 'Status',
  'user.stopLoss.st.active': 'Active',
  'user.stopLoss.st.pending': 'Pending',
  'user.stopLoss.st.completed': 'Completed',
  'user.stopLoss.st.cancelled': 'Cancelled',

  'user.stopLoss.content.loadingPackages': 'Loading stop-loss packages…',
  'user.stopLoss.packageShield': '{{planType}} Shield',
  'user.stopLoss.grid.empty':
    'No stop-loss packages are configured. An admin can add them under Settings → Investment.',

  'user.stopLoss.card.active': 'Active',
  'user.stopLoss.card.activeMulti': 'Active ×{{n}}',
  'user.stopLoss.card.popular': 'Most popular',
  'user.stopLoss.card.premiumPct': '{{n}}% premium',
  'user.stopLoss.card.nonRefundable': 'Non-refundable',
  'user.stopLoss.card.toastInsufficient': 'Insufficient balance. Please deposit first.',
  'user.stopLoss.card.purchase': 'Purchase package',

  'user.stopLoss.slots.title': 'My Stop-Loss slots',
  'user.stopLoss.slots.loading': 'Loading slots…',
  'user.stopLoss.slots.empty': 'No stop-loss slots purchased yet.',
  'user.stopLoss.slots.protectedPlan': 'Protected plan: {{name}}',
  'user.stopLoss.slots.principalCurrent': 'Principal: {{principal}} · Current: {{current}}',
  'user.stopLoss.slots.limitPct': '{{pct}}% loss',
  'user.stopLoss.slots.distance': 'Distance to trigger: {{amount}} away ({{pct}}%)',
  'user.stopLoss.slots.changeLimit': 'Change limit',
  'user.stopLoss.slots.purchasedOn': 'Purchased on {{date}}',
  'user.stopLoss.slots.assignCta': 'Assign to investment plan',
  'user.stopLoss.slots.consumedLine': 'Consumed on {{date}}',
  'user.stopLoss.slots.consumedDetail': 'Triggered on {{plan}} at {{amount}}.',
  'user.stopLoss.slots.planFallback': 'Plan',
  'user.stopLoss.slots.paidPremium': '{{price}} paid · {{premium}}% premium',

  'user.stopLoss.slots.st.active': 'Active',
  'user.stopLoss.slots.st.unassigned': 'Unassigned',
  'user.stopLoss.slots.st.consumed': 'Consumed',

  'user.stopLoss.limit.tabPercentage': 'By percentage',
  'user.stopLoss.limit.tabFixed': 'By fixed value',
  'user.stopLoss.limit.stopsAt': 'Your investment stops at: {{amount}}',
  'user.stopLoss.limit.placeholderFixed': 'Stop when value reaches…',
  'user.stopLoss.limit.lossProtection': 'Loss protection: {{amount}} ({{pct}}%)',
  'user.stopLoss.limitType.percentage': 'Percentage',
  'user.stopLoss.limitType.fixed': 'Fixed',

  'user.stopLoss.assign.title': 'Assign Stop-Loss protection',
  'user.stopLoss.assign.loadingPlans': 'Loading active investments…',
  'user.stopLoss.assign.allProtected': 'All your active investments already have stop-loss protection.',
  'user.stopLoss.assign.planMeta': '{{tier}} · Principal {{principal}} · Current {{current}}',
  'user.stopLoss.assign.protectedPlan': 'Protected plan: {{name}}',
  'user.stopLoss.assign.currentValue': 'Current value: {{amount}}',
  'user.stopLoss.assign.stopLossLimit': 'Stop-loss limit: {{amount}}',
  'user.stopLoss.assign.maxLoss': 'Max loss: {{amount}} ({{pct}}%)',
  'user.stopLoss.assign.toastFail': 'Failed to assign stop-loss',
  'user.stopLoss.assign.toastOk': 'Stop-loss protection activated',
  'user.stopLoss.assign.activate': 'Activate protection',
  'user.stopLoss.assign.activating': 'Activating…',

  'user.stopLoss.update.title': 'Update Stop-Loss limit',
  'user.stopLoss.update.currentLine': 'Current limit: {{amount}} ({{type}})',
  'user.stopLoss.update.newValue': 'New stop-loss value: {{amount}}',
  'user.stopLoss.update.toastFail': 'Failed to update limit',
  'user.stopLoss.update.toastOk': 'Stop-loss limit updated',
  'user.stopLoss.update.submit': 'Update limit',
  'user.stopLoss.update.updating': 'Updating…',

  'user.stopLoss.purchase.title': 'Confirm purchase',
  'user.stopLoss.purchase.packageLine': 'Package: {{name}}',
  'user.stopLoss.purchase.amountLine': 'Amount: {{amount}}',
  'user.stopLoss.purchase.premiumLine': 'Premium: {{n}}% on protected investment',
  'user.stopLoss.purchase.availableLine': 'Available: {{amount}}',
  'user.stopLoss.purchase.warnNonRefundable': 'This payment is non-refundable.',
  'user.stopLoss.purchase.confirm': 'Confirm purchase',
  'user.stopLoss.purchase.processing': 'Processing…',
  'user.stopLoss.purchase.toastFail': 'Purchase failed',
  'user.stopLoss.purchase.toastOk': 'Stop-loss protection applied',
  'user.stopLoss.purchase.planLine': 'Plan: {{name}}',

  'user.stopLoss.protect.title': 'Protect an investment',
  'user.stopLoss.protect.subtitle':
    'Each active plan needs its own stop-loss. The protection fee matches that plan’s invested amount.',
  'user.stopLoss.protect.noInvestments':
    'You need at least one active investment before you can buy stop-loss protection.',
  'user.stopLoss.protect.noInvestmentsCta': 'View investments',
  'user.stopLoss.protect.allProtected': 'All your active plans already have stop-loss protection.',
  'user.stopLoss.protect.loading': 'Loading plans you can protect…',
  'user.stopLoss.protect.planMeta': '{{tier}} · Invested {{principal}} · Current {{current}}',
  'user.stopLoss.protect.feeLine': 'Protection fee (plan amount): {{amount}}',
  'user.stopLoss.protect.premiumLine': 'Premium on protected value: {{n}}%',
  'user.stopLoss.protect.cta': 'Protect this plan',
  'user.stopLoss.protect.ctaChoosePlan': 'Protect a plan…',
  'user.stopLoss.protect.modalTitle': 'Protect {{name}}',
  'user.stopLoss.protect.selectPlanHint': 'Which plan should this stop-loss apply to?',
  'user.stopLoss.protect.confirm': 'Buy & apply protection',
  'user.stopLoss.protect.processing': 'Processing…',
  'user.stopLoss.protect.toastOk': 'Stop-loss applied to your plan',
  'user.stopLoss.protect.choosePackage': 'Choose a stop-loss package',
  'user.stopLoss.protect.planTierLine': 'Investment tier: {{tier}}',
  'user.stopLoss.protect.forTierOnly': 'For {{tier}} investments only',
  'user.stopLoss.protect.recommendedTier': 'Recommended for {{tier}} tier plans',
  'user.stopLoss.protect.continueWithPackage': 'Select package',
  'user.stopLoss.protect.packageSelected': 'Selected',
  'user.stopLoss.protect.setLimitsFor': 'Set protection limits for {{name}}',
  'user.stopLoss.protect.noPackageForTier':
    'No active stop-loss package is configured for {{tier}} in Settings → Investment.',
  'user.stopLoss.table.planProtection': '{{name}} protection',

  'user.stopLoss.explainer.title': 'What is Stop-Loss protection?',
  'user.stopLoss.explainer.body':
    'Stop-loss automatically terminates your investment when its value drops below a predefined threshold you set, protecting your principal from sudden market downturns and volatility.',
  'user.stopLoss.explainer.badge.nonRefundable': 'Non-refundable payment',
  'user.stopLoss.explainer.badge.multi': 'One protection per active plan',
  'user.stopLoss.explainer.badge.monitoring': 'Automated 24/7 monitoring',

  'user.stopLoss.how.title': 'How Stop-Loss works',
  'user.stopLoss.how.step1Title': 'Choose your plan',
  'user.stopLoss.how.step1Desc':
    'Pick which active investment to protect — one stop-loss per plan, fee equals plan amount',
  'user.stopLoss.how.step2Title': 'Apply protection',
  'user.stopLoss.how.step2Desc': 'Select the matching stop-loss package — protection is applied to that plan immediately',
  'user.stopLoss.how.step3Title': '24/7 monitoring',
  'user.stopLoss.how.step3Desc': 'System continuously monitors your investment value',
  'user.stopLoss.how.step4Title': 'Auto-trigger',
  'user.stopLoss.how.step4Desc': 'Investment auto-stops if value crosses your threshold',

  'user.stopLoss.planType.silver': 'Silver',
  'user.stopLoss.planType.gold': 'Gold',
  'user.stopLoss.planType.platinum': 'Platinum',

  'user.stopLoss.feature.slotOneInvestment': '1 slot for 1 investment',
  'user.stopLoss.feature.manualValuationUpdates': 'Manual admin-controlled valuation updates',
  'user.stopLoss.feature.nonRefundableSlot': 'Non-refundable slot purchase',
  'user.stopLoss.feature.flexibleLimits': 'Flexible percentage or fixed value limits',
  'user.stopLoss.feature.limitAdjustable': 'Limit can be adjusted before trigger',
  'user.stopLoss.feature.priorityMonitoring': 'Priority monitoring in admin dashboard',
  'user.stopLoss.feature.immediateClose': 'Immediate close when limit is crossed',
  'user.stopLoss.feature.fixedAmountThreshold': 'Fixed amount threshold',
  'user.stopLoss.feature.emailAlerts': 'Email alerts',
  'user.stopLoss.feature.manualReview': 'Manual review',
  'user.stopLoss.feature.fixedOrPctThreshold': 'Fixed or % threshold',
  'user.stopLoss.feature.priorityAlerts': 'Priority alerts',
  'user.stopLoss.feature.autoTrigger': 'Auto-trigger',
  'user.stopLoss.feature.autoTriggerReport': 'Auto-trigger + report',
  'user.stopLoss.feature.advancedThreshold': 'Advanced threshold options',
  'user.stopLoss.feature.instantAlerts': 'Instant alerts',
  'user.stopLoss.feature.legacyBasicDesc': 'Essential protection for investors starting out',
  'user.stopLoss.feature.legacyStandardDesc': 'Enhanced coverage for active traders',
  'user.stopLoss.feature.legacyFullDesc': 'Maximum protection for large portfolios',

  'user.stopLoss.pkg.silver.label': 'Silver Shield',
  'user.stopLoss.pkg.silver.desc': 'Protect one investment with a moderate drawdown limit.',
  'user.stopLoss.pkg.gold.label': 'Gold Shield',
  'user.stopLoss.pkg.gold.desc': 'Higher-tier stop-loss slot for stronger downside protection.',
  'user.stopLoss.pkg.platinum.label': 'Platinum Shield',
  'user.stopLoss.pkg.platinum.desc': 'Top tier protection slot for premium portfolios.',
  'user.stopLoss.pkg.basic.label': 'Basic Protection',
  'user.stopLoss.pkg.basic.desc': 'Essential protection for investors starting out',
  'user.stopLoss.pkg.standard.label': 'Standard Protection',
  'user.stopLoss.pkg.standard.desc': 'Enhanced coverage for active traders',
  'user.stopLoss.pkg.full.label': 'Full Protection',
  'user.stopLoss.pkg.full.desc': 'Maximum protection for large portfolios',

  'user.investments.earlyWithdraw.title': 'Early withdrawal warning',
  'user.investments.earlyWithdraw.investmentAmount': 'Investment amount:',
  'user.investments.earlyWithdraw.platformFee': 'Platform fee ({{pct}}%):',
  'user.investments.earlyWithdraw.interestForfeited': 'Interest forfeited:',
  'user.investments.earlyWithdraw.interestIncluded': 'Included',
  'user.investments.earlyWithdraw.youReceive': 'You will receive:',
  'user.investments.earlyWithdraw.processing': 'Processing…',
  'user.investments.earlyWithdraw.confirm': 'Confirm',

  'user.investments.active.planFallback': 'Plan',
  'user.investments.active.badgeActive': 'Active',
  'user.investments.stopLossApplied': 'Stop-loss applied',
  'user.investments.active.labelAmount': 'Amount',
  'user.investments.active.labelCurrent': 'Current value',
  'user.investments.active.labelRate': 'Rate',
  'user.investments.active.ratePerMonth': '{{pct}}% / month',
  'user.investments.active.ratePerDay': '{{pct}}% / day',
  'user.investments.active.labelPl': 'P/L',
  'user.investments.active.labelInterestEst': 'Interest (est.)',
  'user.investments.active.labelStart': 'Start date',
  'user.investments.active.labelMaturity': 'Maturity date',
  'user.investments.active.nextWithdrawal': 'Next withdrawal in',
  'user.investments.active.progress': 'Progress',
  'user.investments.active.progressPct': '{{pct}}% complete',
  'user.investments.active.earlyWithdrawCta': 'Early withdraw',

  'agent.withdraw.form.title': 'Withdraw commission',
  'agent.withdraw.form.lockedTitle': 'Withdrawals locked',
  'agent.withdraw.form.lockedHint': 'Complete referral requirements to unlock',
  'agent.withdraw.form.viewRequirements': 'View requirements',
  'agent.withdraw.form.availableLabel': 'Available to withdraw',
  'agent.withdraw.form.pending': 'Pending: {{amount}}',
  'agent.withdraw.form.paidOut': 'Paid out: {{amount}}',
  'agent.withdraw.form.walletLabel': 'USDT TRC20 wallet address',
  'agent.withdraw.form.walletPlaceholder': 'Enter wallet address',
  'agent.withdraw.form.walletHint': 'Agent withdrawals processed only to USDT TRC20. No platform fees.',
  'agent.withdraw.form.amountLabel': 'Amount',
  'agent.withdraw.form.amountPlaceholder': '0.00',
  'agent.withdraw.form.availableLine': 'Available: {{amount}}',
  'agent.withdraw.form.requestCta': 'Request withdrawal',
  'agent.withdraw.form.submitting': 'Submitting…',
  'agent.withdraw.toast.walletRequired': 'Wallet address is required',
  'agent.withdraw.toast.amountInvalid': 'Enter a valid amount',
  'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
  'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
  'agent.withdraw.toast.submitFail': 'Failed to submit withdrawal',
  'agent.withdraw.toast.submitted': 'Withdrawal request submitted',

  'agent.withdraw.unlock.titleUnlocked': 'Withdrawals are unlocked',
  'agent.withdraw.unlock.titleLocked': 'Withdrawals are currently locked',
  'agent.withdraw.unlock.subtitle': 'Complete both requirements below to unlock your withdrawal system',
  'agent.withdraw.unlock.directLabel': 'Direct referrals required',
  'agent.withdraw.unlock.indirectLabel': 'Indirect referrals required',
  'agent.withdraw.unlock.loading': 'Loading…',
  'agent.withdraw.unlock.loadingTitle': 'Checking withdrawal status…',
  'agent.withdraw.unlock.loadingSubtitle': 'Loading your referral progress and unlock requirements',
  'agent.withdraw.form.loadingTitle': 'Loading withdrawal details…',
  'agent.withdraw.form.loadingHint': 'Please wait while we load your balance and unlock status',
  'agent.withdraw.unlock.pctComplete': '{{pct}}% complete',
  'agent.withdraw.unlock.moreNeeded': '{{n}} more needed',
  'agent.withdraw.unlock.requirementMet': 'Requirement met',
  'agent.withdraw.unlock.badgeUnlocked': 'Withdrawals unlocked',
  'agent.withdraw.unlock.badgeLocked': 'Withdrawals locked',
  'agent.withdraw.unlock.footerHint': 'Both requirements must be met',
  'agent.withdraw.unlock.minDepositHint':
    'Only recruited users count (not sub-agents). Each must have at least ${{amount}} in completed deposits.',

  'agent.withdraw.confirm.title': 'Confirm withdrawal',
  'agent.withdraw.confirm.amount': 'Withdrawal amount',
  'agent.withdraw.confirm.fee': 'Platform fee',
  'agent.withdraw.confirm.noFee': 'No fee',
  'agent.withdraw.confirm.net': 'You will receive',
  'agent.withdraw.confirm.submitting': 'Submitting…',
  'agent.withdraw.confirm.confirm': 'Confirm',

  'agent.withdraw.rules.title': 'Withdrawal Rules',
  'agent.withdraw.rules.rule1': 'Available every 30 days from account activation date',
  'agent.withdraw.rules.rule2': 'Only commission balance can be withdrawn — agents do not invest principal',
  'agent.withdraw.rules.rule3': 'Direct to USDT TRC20 wallet only — no other methods',
  'agent.withdraw.rules.rule4': 'No platform fees on agent withdrawals',
  'agent.withdraw.rules.rule5': 'Both referral requirements must be met before first withdrawal',
  'agent.withdraw.rules.processingNote':
    'Withdrawal requests are reviewed and processed within 24–48 hours of submission.',
  'agent.withdraw.rules.windowActive': 'Withdrawal window is active. You can submit requests now.',

  'agent.page.dashboard': 'Dashboard',
  'agent.page.referrals': 'Referrals',
  'agent.page.commissions': 'Commissions',
  'agent.page.team': 'My team',
  'agent.page.transactions': 'Transactions',
  'agent.page.withdraw': 'Withdraw',
  'agent.page.withdrawLogs': 'Withdrawal logs',
  'agent.page.settings': 'Settings',
  'agent.page.notifications': 'Notifications',

  'agent.team.overview.totalMembers': 'Total Team Members',
  'agent.team.overview.activeInvestors': 'Active Investors',
  'agent.team.overview.totalInvested': 'Total Team Invested',
  'agent.team.overview.directUsers': '{{n}} Direct Users',
  'agent.team.overview.indirectUsers': '{{n}} Indirect Users',
  'agent.team.overview.directAgents': '{{n}} Direct Agents',
  'agent.team.overview.indirectAgents': '{{n}} Indirect Agents',

  'agent.team.investment.title': 'Team Investment Breakdown',
  'agent.team.investment.directUser': 'Direct User Team Investment',
  'agent.team.investment.indirectUser': 'Indirect User Team Investment',
  'agent.team.investment.commissionPool': 'Estimated Commission Pool',
  'agent.team.investment.directMembers': '{{n}} direct members',
  'agent.team.investment.indirectMembers': '{{n}} indirect members',
  'agent.team.investment.rateLine': 'Direct {{direct}} + Indirect {{indirect}}',
  'agent.team.investment.avg': 'avg {{amount}}',
  'agent.team.investment.total': 'Total Team Investment',

  'agent.team.members.title': 'Team Members',
  'agent.team.members.filter.all': 'All',
  'agent.team.members.filter.direct': 'Direct',
  'agent.team.members.filter.indirect': 'Indirect',
  'agent.team.members.filter.invested': 'Invested',
  'agent.team.members.filter.notInvested': 'Not Invested',
  'agent.team.members.filter.agents': 'Agents',
  'agent.team.members.filter.users': 'Users',
  'agent.team.members.searchPlaceholder': 'Search by username or email',
  'agent.team.members.col.userId': 'User ID',
  'agent.team.members.col.type': 'Type',
  'agent.team.members.col.member': 'Member',
  'agent.team.members.col.joined': 'Joined',
  'agent.team.members.col.invested': 'Amount Invested',
  'agent.team.members.col.status': 'Status',
  'agent.team.members.loading': 'Loading team members…',
  'agent.team.members.empty': 'No team members found.',
  'agent.team.members.showing': 'Showing {{n}} members',
  'agent.team.level.direct': 'Direct',
  'agent.team.level.indirect': 'Indirect',
  'agent.team.memberType.agent': 'Agent',
  'agent.team.memberType.user': 'User',
  'agent.team.status.active': 'Active',
  'agent.team.status.suspended': 'Suspended',

  'agent.signup.title': 'Agent sign up',
  'agent.signup.subtitle':
    'Create your agent account. After registration, an admin must approve your account before you can sign in.',
  'agent.signup.secondaryText': 'Already have an account?',
  'agent.signup.secondaryLabel': 'Sign in',
  'agent.signup.backToSite': 'Back to main site',
  'agent.signup.toastCreated':
    'Account registered — pending admin approval. You cannot sign in until approved.',
  'agent.signup.toastSaveRecoveryFirst':
    'Account registered — save your recovery phrase. Login stays locked until admin approval.',
  'agent.signup.pendingNotice':
    'Your agent account is pending admin approval. You cannot log in until it is activated. Contact support@mineme.site if you need help.',
  'agent.signup.error.nameRequired': 'Full name is required.',
  'agent.signup.error.usernameInvalid':
    'Username must contain only letters, numbers, and optional hyphens.',
  'agent.signup.error.usernameMin':
    'Username must be at least {{min}} characters (after removing hyphens).',
  'agent.signup.error.usernameMax': 'Username must be at most {{max}} characters.',
  'agent.signup.error.usernameTaken': 'This username is already taken.',
  'agent.signup.error.usernameCheckWait': 'Please wait for the username check to finish.',
  'agent.signup.error.emailRequired': 'Email is required.',
  'agent.signup.error.passwordRequired': 'Password is required.',
  'agent.signup.error.confirmRequired': 'Confirm password is required.',
  'agent.signup.error.passwordsMismatch': 'Passwords do not match.',
  'agent.signup.error.passwordMin': 'Password must be at least 8 characters.',
  'agent.signup.error.captchaWrong': 'Captcha is mandatory and must be correct.',
  'agent.signup.error.referralRequired': 'Agent referral code is required.',
  'agent.signup.error.referralInvalid':
    'Referral code must contain only letters, numbers, and optional hyphens.',
  'agent.signup.error.registrationFailed': 'Registration failed',
  'agent.signup.form.labelFullName': 'Full name',
  'agent.signup.form.placeholderFullName': 'Your legal name',
  'agent.signup.form.labelUsername': 'Username',
  'agent.signup.form.placeholderUsername': 'Choose agent login username',
  'agent.signup.form.usernameHint':
    '{{min}}–{{max}} characters after removing hyphens; letters and numbers (hyphens allowed when typing).',
  'agent.signup.form.labelReferral': 'Agent referral code (required)',
  'agent.signup.form.placeholderReferral': 'Sponsor agent username',
  'agent.signup.form.referralHint':
    'Only an existing agent can refer a new agent. User accounts cannot be used here.',
  'agent.signup.form.labelEmail': 'Email',
  'agent.signup.form.placeholderEmail': 'Enter email',
  'agent.signup.form.labelPassword': 'Password',
  'agent.signup.form.placeholderPassword': 'Create password',
  'agent.signup.form.labelConfirmPassword': 'Confirm password',
  'agent.signup.form.placeholderConfirmPassword': 'Confirm password',
  'agent.signup.form.captchaRobot': "I'm not a robot (mandatory)",
  'agent.signup.form.captchaQuestion': 'Captcha: What is {{a}} + {{b}}?',
  'agent.signup.form.placeholderCaptcha': 'Enter captcha answer',
  'agent.signup.form.submitting': 'Creating…',
  'agent.signup.form.submit': 'Create account',
  'agent.signup.username.available': 'This username is available.',
  'agent.signup.username.taken': 'This username is already taken.',
  'agent.signup.username.invalidChars': 'Use only letters, numbers, and optional hyphens.',
  'agent.signup.username.invalidMin':
    'Username must be at least {{min}} characters (after removing hyphens).',
  'agent.signup.username.invalidGeneric': 'This username cannot be used.',
  'agent.signup.recovery.title': 'Save your recovery phrase',
  'agent.signup.recovery.body':
    'This is the only time we can show it. Write it down and store it offline. You will need it to reset your password if you forget it.',
  'agent.signup.recovery.warn':
    'Never share this phrase. Anyone with it can reset your password.',
  'agent.signup.recovery.copy': 'Copy phrase',
  'agent.signup.recovery.copiedToast': 'Phrase copied',
  'agent.signup.recovery.checkbox':
    'I have written down or securely saved my 12-word recovery phrase.',
  'agent.signup.recovery.continue': 'Continue',
  'agent.profile.cropPhotoTitle': 'Crop agent photo',

  'agent.referrals.rankExplainer':
    'Only referred users count (not sponsored agents). Each must reach that tier’s min deposit before they count toward your rank.',
  'agent.referrals.currentRank.minDeposit': '· {{amount}} min deposit',
  'agent.commissions.tierExplainer':
    'Reach the next tier on the right to unlock a one-time reward credited to your commission balance.',
  'agent.referrals.rankingFootnote':
    'Min deposit = completed deposits required from each referred user for that tier. One-time tier reward credits when both ref requirements are met.',
  'agent.commissions.rankingFootnote':
    'One-time tier reward is credited the first time both direct and indirect requirements are met.',

  'agent.commissions.summary.totalEarned': 'Total Earned',
  'agent.commissions.summary.thisMonth': 'This Month',
  'agent.commissions.summary.pendingPayout': 'Pending Payout',
  'agent.commissions.summary.totalPaidOut': 'Total Paid Out',

  'agent.commissions.rates.title': 'Your Commission Rates',
  'agent.commissions.rates.directTitle': 'Direct Commission',
  'agent.commissions.rates.directHint': 'Earned on every investment your direct referrals make',
  'agent.commissions.rates.indirectTitle': 'Indirect Commission',
  'agent.commissions.rates.indirectHint': 'Earned on investments from indirect referrals',
  'agent.commissions.rates.scheduleLoading': 'Commission credit schedule loading…',
  'agent.commissions.rates.scheduleInstant':
    'Commission is credited and withdrawable instantly after investment confirmation.',
  'agent.commissions.rates.scheduleAfterOne':
    'Commission is credited and withdrawable 1 day after investment confirmation.',
  'agent.commissions.rates.scheduleAfterMany':
    'Commission is credited and withdrawable {{days}} days after investment confirmation.',

  'agent.commissions.monthly.title': 'This Month at a Glance',
  'agent.commissions.monthly.subtitle':
    'Live team activity and commissions credited so far this month.',
  'agent.commissions.monthly.teamInvested': 'Team Total Invested',
  'agent.commissions.monthly.activeMembers': 'Active Members',
  'agent.commissions.monthly.yourCommission': 'Your Commission',
  'agent.commissions.monthly.calcTitle': "How It's Calculated",
  'agent.commissions.monthly.directRate': 'Direct rate',
  'agent.commissions.monthly.directRateLine': '{{pct}} of each direct referral\'s investment',
  'agent.commissions.monthly.indirectRate': 'Indirect rate',
  'agent.commissions.monthly.indirectRateLine': '{{pct}} of each indirect referral\'s investment',
  'agent.commissions.monthly.settlement': 'Settlement',
  'agent.commissions.monthly.scheduleLoading': 'Loading…',
  'agent.commissions.monthly.scheduleInstant': 'Instant on confirmation',
  'agent.commissions.monthly.scheduleAfterOne': '1 day after confirmation',
  'agent.commissions.monthly.scheduleAfterMany': '{{days}} days after confirmation',
  'agent.commissions.monthly.creditedSoFar': 'Credited so far this month',
  'agent.commissions.monthly.footer':
    'Every commission is credited to your balance once the settlement window above elapses for that investment. Rank-tier rewards are credited immediately when both direct and indirect requirements are met.',

  'agent.commissions.history.title': 'Commission History',
  'agent.commissions.filter.all': 'All',
  'agent.commissions.filter.direct': 'Direct',
  'agent.commissions.filter.indirect': 'Indirect',
  'agent.commissions.filter.rankReward': 'Rank Reward',
  'agent.commissions.source.direct': 'Direct',
  'agent.commissions.source.indirect': 'Indirect',
  'agent.commissions.source.rankReward': 'Rank Reward',
  'agent.commission.status.cancelled': 'Cancelled',
  'agent.commissions.history.col.date': 'Date',
  'agent.commissions.history.col.source': 'Source',
  'agent.commissions.history.col.userTeam': 'User / Team',
  'agent.commissions.history.col.commission': 'Commission',
  'agent.commissions.history.col.status': 'Status',
  'agent.commissions.history.from': 'From',
  'agent.commissions.history.to': 'To',
  'agent.commissions.history.clearDates': 'Clear dates',
  'agent.commissions.history.loading': 'Loading commission history...',
  'agent.commissions.history.empty': 'No commission rows found.',
  'agent.commissions.history.pagination':
    'Page {{page}} of {{totalPages}} · {{perPage}} per page',
  'agent.commissions.history.previous': 'Previous',
  'agent.commissions.history.next': 'Next',

  'agent.referrals.tabDirect': 'Direct referrals ({{count}})',
  'agent.referrals.tabIndirect': 'Indirect referrals ({{count}})',
  'agent.referrals.tabLeaderboard': 'Leaderboard',
  'agent.referrals.tabLeaderboardCount': 'Leaderboard ({{count}})',

  'agent.referrals.link.title': 'Your Agent Referral Link',
  'agent.referrals.link.loading': 'Loading referral link...',
  'agent.referrals.link.share': 'Share',
  'agent.referrals.link.shareTitle': 'Join MineMe',
  'agent.referrals.link.shareText': 'Register with my agent referral link',
  'agent.referrals.link.toastUnavailable': 'Referral link is not available yet',
  'agent.referrals.link.toastCopied': 'Link copied to clipboard',
  'agent.referrals.link.toastCopyFailed': 'Could not copy link',
  'agent.referrals.link.scheduleInstant': 'Commission is credited and withdrawable instantly.',
  'agent.referrals.link.scheduleAfterOne':
    'Commission is credited and withdrawable after 1 day.',
  'agent.referrals.link.scheduleAfterMany':
    'Commission is credited and withdrawable after {{days}} days.',
  'agent.referrals.link.earningsWithIndirect':
    'You earn {{directPct}} commission on all their investments, and {{indirectPct}} on their referrals\' investments.',
  'agent.referrals.link.earningsDirectOnly':
    'You earn {{directPct}} commission on all their investments.',
  'agent.referrals.link.intro':
    'Every user who registers using your link becomes your direct referral. {{earnings}}{{schedule}}',

  'agent.referrals.stats.directLabel': 'Direct Referrals',
  'agent.referrals.stats.indirectLabel': 'Indirect Referrals',
  'agent.referrals.stats.conversionLabel': 'Conversion Rate',
  'agent.referrals.stats.conversionHint': 'Active = account status (not whether they invested)',
  'agent.referrals.stats.activeTotal': '{{active}} active / {{total}} total',
  'agent.referrals.stats.loading': 'Loading…',
  'agent.referrals.stats.loadingBadge': 'Loading...',
  'agent.referrals.stats.noTiers': 'No rank tiers loaded — check admin Referral rank tiers.',
  'agent.referrals.stats.allTargetsMet': 'All configured tier targets met',
  'agent.referrals.stats.directTargetsNotSet':
    'Direct referral targets are not set on rank tiers (admin).',
  'agent.referrals.stats.indirectTargetsNotSet':
    'Indirect referral targets are not set on rank tiers (admin).',
  'agent.referrals.stats.directMetForTier': 'Direct requirement met for {{tier}}',
  'agent.referrals.stats.directMoreToReach': '{{remaining}} more to reach {{tier}} ({{target}})',
  'agent.referrals.stats.indirectMetForTier': 'Indirect requirement met for {{tier}}',
  'agent.referrals.stats.indirectMoreToReach': '{{remaining}} more to reach {{tier}} ({{target}})',
  'agent.referrals.stats.nextTierDefault': 'next tier',

  'agent.referrals.filter.all': 'All',
  'agent.referrals.filter.active': 'Active',
  'agent.referrals.filter.suspended': 'Suspended',

  'agent.referrals.table.directTitle': 'Direct Referrals',
  'agent.referrals.table.indirectTitle': 'Indirect Referrals',
  'agent.referrals.table.indirectSubtitle': 'Second-level team',
  'agent.referrals.table.searchPlaceholder': 'Search by username or email',
  'agent.referrals.table.col.userId': 'User ID',
  'agent.referrals.table.col.type': 'Type',
  'agent.referrals.table.col.name': 'Name',
  'agent.referrals.table.col.email': 'Email',
  'agent.referrals.table.col.joined': 'Joined Date',
  'agent.referrals.table.col.status': 'Status',
  'agent.referrals.table.col.deposited': 'Deposited',
  'agent.referrals.table.col.countsTowardRank': 'Counts',
  'agent.referrals.table.countsYes': 'Yes',
  'agent.referrals.table.countsNo': 'No',
  'agent.referrals.table.col.referredVia': 'Referred Via',
  'agent.referrals.table.loadingDirect': 'Loading direct referrals...',
  'agent.referrals.table.loadingIndirect': 'Loading indirect referrals...',
  'agent.referrals.table.emptyDirect': 'No direct referrals found.',
  'agent.referrals.table.emptyIndirect': 'No indirect referrals found.',
  'agent.referrals.table.showingDirect': 'Showing {{count}} direct referrals',
  'agent.referrals.table.showingIndirect': 'Showing {{count}} indirect referrals',
  'agent.referrals.table.status.active': 'Active',
  'agent.referrals.table.status.suspended': 'Suspended',
  'agent.referrals.table.memberType.agent': 'Agent',
  'agent.referrals.table.memberType.user': 'User',
  'agent.referrals.table.via': 'via @{{username}}',

  'agent.referrals.leaderboard.title': 'Top earners',
  'agent.referrals.leaderboard.subtitle': 'Ranked by lifetime commission · top {{limit}}',
  'agent.referrals.leaderboard.col.position': '#',
  'agent.referrals.leaderboard.col.agent': 'Agent',
  'agent.referrals.leaderboard.col.rank': 'Rank',
  'agent.referrals.leaderboard.col.team': 'Team',
  'agent.referrals.leaderboard.col.earned': 'Earned',
  'agent.referrals.leaderboard.loading': 'Loading leaderboard…',
  'agent.referrals.leaderboard.error': "Couldn't load leaderboard right now.",
  'agent.referrals.leaderboard.empty':
    'No active agents yet — sign up your first referral to break onto the board.',
  'agent.referrals.leaderboard.yourPosition': 'Your position',
  'agent.referrals.leaderboard.badgeYou': 'You',
  'agent.referrals.leaderboard.lifetimeEarnings': 'Lifetime earnings',
  'agent.referrals.leaderboard.teamCounts': '{{direct}} direct · {{indirect}} indirect',
  'agent.referrals.leaderboard.rank.topRank': 'Top rank',
  'agent.referrals.leaderboard.rank.rewardEarned': 'Reward earned',
  'agent.referrals.leaderboard.rank.workingToward': 'Working toward',
  'agent.referrals.leaderboard.rank.unranked': 'Unranked',
  'agent.referrals.leaderboard.fallbackName': 'Agent',

  'agent.referral.level.direct': 'Direct',
  'agent.referral.level.indirect': 'Indirect',
  'agent.referral.memberType.agent': 'Agent signup',
  'agent.referral.memberType.user': 'User signup',
  'agent.commission.status.pending': 'Pending',
  'agent.commission.status.paid': 'Paid',

  'agent.dashboard.overview.totalEarned': 'Total Earned',
  'agent.dashboard.overview.totalEarnedHint': 'Commissions + tier rewards (lifetime)',
  'agent.dashboard.overview.directReferrals': 'Direct Referrals',
  'agent.dashboard.overview.directDelta': '{{n}} more to unlock',
  'agent.dashboard.overview.indirectReferrals': 'Indirect Referrals',
  'agent.dashboard.overview.indirectDelta': '{{n}} more to unlock',
  'agent.dashboard.overview.commissionBalance': 'Commission Balance',
  'agent.dashboard.overview.availableToWithdraw': 'Available to withdraw',
  'agent.dashboard.progress.loadingShort': 'Loading…',

  'agent.dashboard.direct.title': 'Direct Referrals',
  'agent.dashboard.direct.subtitle': 'Toward withdrawal unlock',
  'agent.dashboard.direct.required': 'direct referrals required',
  'agent.dashboard.direct.axisZero': '0 referrals',
  'agent.dashboard.direct.axisTarget': '{{n}} target',
  'agent.dashboard.direct.progress': '{{current}} of {{target}} completed',
  'agent.dashboard.direct.remaining': '{{n}} more needed',
  'agent.dashboard.direct.inProgress': 'In Progress',
  'agent.dashboard.direct.info':
    'Reach 50 direct referrals to activate your withdrawal system. Each direct referral must register using your unique referral link.',

  'agent.dashboard.indirect.title': 'Indirect Referrals',
  'agent.dashboard.indirect.subtitle': 'Toward withdrawal unlock',
  'agent.dashboard.indirect.required': 'indirect referrals required',
  'agent.dashboard.indirect.axisZero': '0 referrals',
  'agent.dashboard.indirect.axisTarget': '{{n}} target',
  'agent.dashboard.indirect.progress': '{{current}} of {{target}} completed',
  'agent.dashboard.indirect.remaining': '{{n}} more needed',
  'agent.dashboard.indirect.inProgress': 'In Progress',
  'agent.dashboard.indirect.info':
    'Indirect referrals come from your direct referrals’ own referrals.',

  'agent.dashboard.unlock.active.title': 'Withdrawal System is Active',
  'agent.dashboard.unlock.active.subtitle':
    'You have met both requirements. Withdrawals are enabled.',
  'agent.dashboard.unlock.active.directLabel': 'Direct referrals',
  'agent.dashboard.unlock.active.indirectLabel': 'Indirect referrals',
  'agent.dashboard.unlock.active.met': 'Met',
  'agent.dashboard.unlock.active.badge': 'Active',

  'agent.dashboard.unlock.locked.title': 'Withdrawal System is Currently Locked',
  'agent.dashboard.unlock.locked.subtitle':
    'Complete both requirements below to activate your withdrawal system',
  'agent.dashboard.unlock.locked.directHeading': 'DIRECT REFERRALS',
  'agent.dashboard.unlock.locked.indirectHeading': 'INDIRECT REFERRALS',
  'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% complete',
  'agent.dashboard.unlock.locked.moreNeeded': '{{n}} more',
  'agent.dashboard.unlock.locked.badge': 'Locked',

  'agent.dashboard.commission.title': 'Commission Breakdown',
  'agent.dashboard.commission.directRow': 'Direct Referral ({{pct}})',
  'agent.dashboard.commission.indirectRow': 'Indirect Referral ({{pct}})',
  'agent.dashboard.commission.directHelper': 'estimated from direct user investments',
  'agent.dashboard.commission.indirectHelper': 'estimated from indirect user investments',
  'agent.dashboard.commission.footerTitle': 'Projected from team',
  'agent.dashboard.commission.footerHint':
    'Forecast — actual earnings live in “Total Earned” above.',
  'agent.dashboard.commission.percentPending': '—%',

  'agent.dashboard.recentActivity.title': 'Recent referral activity',
  'agent.dashboard.recentActivity.viewAll': 'View all',
  'agent.dashboard.recentActivity.col.user': 'User',
  'agent.dashboard.recentActivity.col.type': 'Type',
  'agent.dashboard.recentActivity.col.joined': 'Joined',
  'agent.dashboard.recentActivity.col.investment': 'Investment',
  'agent.dashboard.recentActivity.col.commission': 'Commission',
  'agent.dashboard.recentActivity.loading': 'Loading activity…',
  'agent.dashboard.recentActivity.empty': 'No referral activity yet.',

  'agent.transactions.sectionTitle': 'Transaction history',
  'agent.transactions.loading': 'Loading transactions…',
  'agent.transactions.emptyTitle': 'No transactions found',
  'agent.transactions.emptyLoadingHint': 'Please wait…',
  'agent.transactions.emptyHint': 'Try adjusting your filters.',
  'agent.transactions.col.date': 'Date & time',
  'agent.transactions.col.type': 'Type',
  'agent.transactions.col.description': 'Description',
  'agent.transactions.col.amount': 'Amount',
  'agent.transactions.col.status': 'Status',
  'agent.transactions.col.txid': 'TXID',
  'agent.transactions.footerShowing': 'Showing 1–{{to}} of {{total}}',
  'agent.transactions.prev': 'Prev',
  'agent.transactions.next': 'Next',
  'agent.transactions.pending': 'Pending',

  'agent.transactions.filter.all': 'All',
  'agent.transactions.filter.from': 'From',
  'agent.transactions.filter.to': 'To',
  'agent.transactions.filter.searchPlaceholder': 'Search TXID or description…',

  'agent.transactions.type.commission': 'Commission',
  'agent.transactions.type.withdrawal': 'Withdrawal',
  'agent.transactions.type.rankReward': 'Rank Reward',

  'agent.transactions.status.pending': 'Pending',
  'agent.transactions.status.paid': 'Paid',
  'agent.transactions.status.completed': 'Completed',
  'agent.transactions.status.failed': 'Failed',
  'agent.transactions.status.rejected': 'Rejected',
  'agent.transactions.status.cancelled': 'Cancelled',

  'agent.withdrawLogs.sectionTitle': 'Withdrawal history',
  'agent.withdrawLogs.loading': 'Loading withdrawals…',
  'agent.withdrawLogs.emptyTitle': 'No withdrawals yet',
  'agent.withdrawLogs.emptyDesc': 'Your withdrawal history will appear here',
  'agent.withdrawLogs.emptyLoadingHint': 'Please wait…',

  'agent.withdrawLogs.col.date': 'Date',
  'agent.withdrawLogs.col.amount': 'Amount',
  'agent.withdrawLogs.col.wallet': 'Wallet address',
  'agent.withdrawLogs.col.status': 'Status',
  'agent.withdrawLogs.col.txid': 'TXID',

  'agent.logs.emptyTitle': 'No withdrawals found',
  'agent.logs.emptyDescAdjust': 'Try adjusting your filters or date range',
  'agent.withdrawLogs.showingCount': 'Showing {{n}} withdrawals',

  'agent.logs.subtitle': 'Complete history of all withdrawal requests',
  'agent.logs.loadingRows': 'Loading withdrawals…',
  'agent.logs.col.dateTime': 'Date & time',
  'agent.logs.col.amount': 'Amount',
  'agent.logs.col.wallet': 'Wallet',
  'agent.logs.col.network': 'Network',
  'agent.logs.col.fee': 'Fee',
  'agent.logs.col.status': 'Status',
  'agent.logs.col.txid': 'TXID',
  'agent.logs.col.processedIn': 'Processed in',
  'agent.logs.expanded.txId': 'Transaction ID',
  'agent.logs.expanded.fullWallet': 'Full wallet address',
  'agent.logs.expanded.network': 'Network',
  'agent.logs.expanded.processingTime': 'Processing time',
  'agent.logs.awaitingReview': 'Awaiting review',
  'agent.logs.failedHelp':
    'This withdrawal failed. Please contact support with TXID {{txid}} for assistance.',
  'agent.logs.pendingNotice': 'Withdrawal is under review. Processing time is 24–48 hours.',
  'agent.logs.status.completed': 'Completed',
  'agent.logs.status.pending': 'Pending',
  'agent.logs.status.failed': 'Failed',

  'agent.logs.filter.all': 'All',
  'agent.logs.filter.from': 'From',
  'agent.logs.filter.to': 'To',
  'agent.logs.filter.searchPlaceholder': 'Search by TXID or wallet...',

  'agent.logs.summary.totalWithdrawn': 'Total Withdrawn',
  'agent.logs.summary.lastWithdrawal': 'Last Withdrawal',
  'agent.logs.summary.nextAvailable': 'Next Available',
  'agent.logs.summary.subTotalWithdrawn': 'Successful withdrawals',
  'agent.logs.summary.subNextOpen': 'You can request now',
  'agent.logs.summary.subNextLocked': 'Complete referral requirements',
  'agent.logs.summary.open': 'Open',
  'agent.logs.summary.locked': 'Locked',
  'agent.logs.summary.loading': 'Loading…',
};
